function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import React from 'react';
import ReactDOM from 'react-dom';
import queryString from 'query-string';
import { connect } from 'react-redux';
import API from '../api';
import Filter from '../components/filter';
import Toolbar from '../components/toolbar';
import ProductCard from '../components/product-card';
import FilterToggle from '../components/filter-toggle';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Products = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Products, _React$PureComponent);
  var _super = _createSuper(Products);
  function Products(props) {
    var _this;
    _classCallCheck(this, Products);
    _this = _super.call(this, props);
    _this.container = document.querySelector('.js-products');
    _this.renderProducts = _this.renderProducts.bind(_assertThisInitialized(_this));
    _this.addFilter = _this.addFilter.bind(_assertThisInitialized(_this));
    _this.removeFilter = _this.removeFilter.bind(_assertThisInitialized(_this));
    _this.clearFilters = _this.clearFilters.bind(_assertThisInitialized(_this));
    _this.changeLayout = _this.changeLayout.bind(_assertThisInitialized(_this));
    _this.changeSort = _this.changeSort.bind(_assertThisInitialized(_this));
    _this.handlePageChange = _this.handlePageChange.bind(_assertThisInitialized(_this));
    _this.handleToggleFilters = _this.handleToggleFilters.bind(_assertThisInitialized(_this));
    _this.setCurrentSector = _this.setCurrentSector.bind(_assertThisInitialized(_this));
    _this.setCurrentUsage = _this.setCurrentUsage.bind(_assertThisInitialized(_this));
    _this.state = {
      layout: 'grid',
      sort: 'popularity',
      sectors: [],
      products: [],
      usages: [],
      materials: [],
      filters: {
        sectors: [],
        types: [],
        usages: [],
        materials: []
      },
      currentSector: {
        ID: null
      },
      filtersOpen: window.matchMedia('all and (min-width: 1049px)').matches,
      activePage: 1,
      pageLength: 18,
      noProducts: true,
      filteredProductsLength: 0,
      productsLoaded: false
    };
    return _this;
  }
  _createClass(Products, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.container.innerHTML = '';
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var productQuery = queryString.parse(location.search);
      var sectorID = window.iplexShop.sector ? parseInt(window.iplexShop.sector, 0) : null;
      var usageID = window.iplexShop.usage ? parseInt(window.iplexShop.usage, 0) : null;
      Promise.resolve(API.request('sectors', 'GET').then(function (results) {
        _this2.setState({
          sectors: results
        }, function () {
          if (sectorID && !_this2.state.currentSector.ID) {
            // TODO do not display products until this value is set to force FOUC to stop
            _this2.setCurrentSector(sectorID);
          }
        });
      }));
      Promise.resolve(API.request('usages', 'GET').then(function (results) {
        _this2.setState({
          usages: results
        }, function () {
          if (usageID) {
            // TODO do not display products until this value is set to force FOUC to stop
            _this2.setCurrentUsage(usageID);
          }
        });
      }));
      Promise.resolve(API.request('materials', 'GET').then(function (results) {
        _this2.setState({
          materials: results
        });
      }));
      var url = window.location.href;
      var regex = new RegExp('[?&]query(=([^&#]*)|&|#|$)');
      var results = regex.exec(url);
      if (results && results[2]) {
        this.handleSearch();
      } else {
        if (sectorID) {
          Promise.resolve(API.request('products', 'GET', '?sector=' + sectorID).then(function (results) {
            setTimeout(function () {
              _this2.setState({
                products: results,
                productsLoaded: true
              });
            }, 1500);
          }));
        } else {
          Promise.resolve(API.request('products', 'GET').then(function (results) {
            setTimeout(function () {
              _this2.setState({
                products: results,
                productsLoaded: true
              });
            }, 1500);
          }));
        }
      }
    }
  }, {
    key: "setCurrentSector",
    value: function setCurrentSector(sectorID) {
      var sectors = this.state.sectors;
      var currentSectorDesc = '';
      var currentSectorLink = '';
      var currentUsages = {};
      sectors.forEach(function (sector) {
        if (sectorID === sector.ID) {
          currentSectorDesc = sector.Description;
          currentSectorLink = sector.SectorLink;
          currentUsages = sector.Usages;
        }
      });
      this.setState({
        currentSector: {
          ID: sectorID,
          description: currentSectorDesc,
          link: currentSectorLink,
          usages: currentUsages
        }
      });
    }
  }, {
    key: "setCurrentUsage",
    value: function setCurrentUsage(usageID) {
      this.setState({
        filters: _objectSpread(_objectSpread({}, this.state.filters), {}, {
          usages: [].concat(_toConsumableArray(this.state.filters.usages), [usageID])
        })
      });
    }
  }, {
    key: "handleToggleFilters",
    value: function handleToggleFilters(e) {
      e.preventDefault();
      if (this.state.filtersOpen) {
        document.body.classList.remove('is-locked');
      } else {
        document.body.classList.add('is-locked');
      }
      this.setState({
        filtersOpen: !this.state.filtersOpen
      });
    }
  }, {
    key: "addFilter",
    value: function addFilter(e) {
      var filterID = parseInt(e.currentTarget.value, 10);
      var _this$state$filters = this.state.filters,
        usages = _this$state$filters.usages,
        materials = _this$state$filters.materials;
      var filterType = e.currentTarget.dataset.filterType;
      if (filterType === 'usage' && !usages.includes(filterID)) {
        // Add the selected product to the selectedProducts state if it doesn't already exist
        this.setState({
          filters: _objectSpread(_objectSpread({}, this.state.filters), {}, {
            usages: [].concat(_toConsumableArray(this.state.filters.usages), [filterID])
          })
        });
      } else if (filterType === 'material' && !materials.includes(filterID)) {
        // Add the selected product to the selectedProducts state if it doesn't already exist
        this.setState({
          filters: _objectSpread(_objectSpread({}, this.state.filters), {}, {
            materials: [].concat(_toConsumableArray(this.state.filters.materials), [filterID])
          })
        });
      } else {
        this.removeFilter(e);
      }

      // Reset active page
      this.setState({
        activePage: 1
      });
    }
  }, {
    key: "removeFilter",
    value: function removeFilter(e) {
      var filterType = e.currentTarget.dataset.filterType;
      if (filterType === 'usage') {
        var filters = this.state.filters.usages;
        var filterIndex = filters.indexOf(parseInt(e.currentTarget.value, 10));
        filters.splice(filterIndex, 1);
        this.setState({
          filters: _objectSpread(_objectSpread({}, this.state.filters), {}, {
            usages: _toConsumableArray(filters)
          })
        });
      } else if (filterType === 'material') {
        var _filters = this.state.filters.materials;
        var _filterIndex = _filters.indexOf(parseInt(e.currentTarget.value, 10));
        _filters.splice(_filterIndex, 1);
        this.setState({
          filters: _objectSpread(_objectSpread({}, this.state.filters), {}, {
            materials: _toConsumableArray(_filters)
          })
        });
      }

      // Reset active page
      this.setState({
        activePage: 1
      });
    }
  }, {
    key: "clearFilters",
    value: function clearFilters() {
      this.setState({
        filters: {
          sectors: [],
          types: [],
          usages: [],
          materials: []
        },
        activePage: 1
      });
    }
  }, {
    key: "handleSearch",
    value: function handleSearch() {
      var _this3 = this;
      var url = window.location.href;
      var regex = new RegExp('[?&]query(=([^&#]*)|&|#|$)');
      var results = regex.exec(url);
      if (results) {
        var query = decodeURIComponent(results[2].replace(/\+/g, ' '));
        if (results[2]) {
          Promise.resolve(API.request('searchProducts', 'GET', query)).then(function (products) {
            _this3.setState({
              products: products,
              productsLoaded: true
            });
          });
        }
      }
    }
  }, {
    key: "changeLayout",
    value: function changeLayout(e) {
      var value = e.currentTarget.value;
      this.setState({
        layout: value
      });
    }
  }, {
    key: "changeSort",
    value: function changeSort(e) {
      var value = e.currentTarget.value;
      this.setState({
        sort: value,
        activePage: 1
      });
    }
  }, {
    key: "handlePageChange",
    value: function handlePageChange(activePage) {
      this.setState({
        activePage: activePage
      });
    }
  }, {
    key: "renderProducts",
    value: function renderProducts() {
      var _this4 = this;
      var _this$state = this.state,
        filters = _this$state.filters,
        products = _this$state.products,
        sort = _this$state.sort;
      var sortedProducts = [];
      var filterArrays = [];
      if (this.state.currentSector.ID) {
        var contextualProducts = [];
        products.forEach(function (product) {
          console.log(product.Sectors);
          if (product.Sectors.includes(_this4.state.currentSector.ID) && !contextualProducts.includes(product)) {
            contextualProducts = [].concat(_toConsumableArray(contextualProducts), [product]);
          }
        });
        filterArrays.push(contextualProducts);
      }
      if (filters.usages.length) {
        var _contextualProducts = [];
        products.forEach(function (product) {
          filters.usages.forEach(function (usage) {
            if (product.Usages.includes(usage) && !_contextualProducts.includes(product)) {
              _contextualProducts = [].concat(_toConsumableArray(_contextualProducts), [product]);
            }
          });
        });
        filterArrays.push(_contextualProducts);
      }
      if (filters.materials.length) {
        var _contextualProducts2 = [];
        products.forEach(function (product) {
          filters.materials.forEach(function (usage) {
            if (product.Materials.includes(usage) && !_contextualProducts2.includes(product)) {
              _contextualProducts2 = [].concat(_toConsumableArray(_contextualProducts2), [product]);
            }
          });
        });
        filterArrays.push(_contextualProducts2);
      }
      var currentFilteredProducts = products.filter(function (product) {
        var exists = false;
        var count = 0;
        filterArrays.forEach(function (filterArray) {
          filterArray.forEach(function (filterProduct) {
            if (product.ID === filterProduct.ID) {
              count += 1;
            }
          });
        });
        if (count === filterArrays.length) {
          exists = true;
        }
        return exists;
      });
      if (sort === 'az' || sort === 'za') {
        sortedProducts = _toConsumableArray(currentFilteredProducts).sort(function (a, b) {
          if (a.Title && b.Title) {
            var titleA = a.Title.toUpperCase();
            var titleB = b.Title.toUpperCase();
            if (titleA < titleB) {
              return sort === 'az' ? -1 : 1;
            } else if (titleA > titleB) {
              return sort === 'az' ? 1 : -1;
            }
          }
          return 0;
        });
      } else if (sort === 'popularity') {
        sortedProducts = _toConsumableArray(currentFilteredProducts).sort(function (a, b) {
          return a.SortOrder - b.SortOrder;
        });
      }
      var start = this.state.activePage === 1 ? 1 : this.state.pageLength * (this.state.activePage - 1) + 1;
      var end = start + this.state.pageLength - 1;
      var paginatedProducts = sortedProducts.slice(start - 1, end);
      if (paginatedProducts.length) {
        this.setState({
          noProducts: false,
          filteredProductsLength: sortedProducts.length
        });
        return paginatedProducts.map(function (product) {
          return /*#__PURE__*/_jsx(ProductCard, {
            code: product.Code,
            image: product.Image,
            title: product.Title,
            link: product.Link,
            layout: _this4.state.layout
          }, product.ID);
        });
      }
      this.setState({
        noProducts: true
      });
      return /*#__PURE__*/_jsx("div", {
        className: "c-info-block",
        children: /*#__PURE__*/_jsx("h4", {
          children: "Sorry, there are no products which match your criteria."
        })
      });
    }
  }, {
    key: "render",
    value: function render() {
      // Paginate products
      var totalProducts = this.state.filteredProductsLength;
      // start from 1 if on first page...otherwise something...
      var start = this.state.activePage === 1 ? 1 : this.state.pageLength * (this.state.activePage - 1) + 1;
      var end = start + this.state.pageLength - 1;
      return /*#__PURE__*/ReactDOM.createPortal([/*#__PURE__*/_jsx(React.Fragment, {
        children: /*#__PURE__*/_jsxs("div", {
          className: "l-columns l-columns--quarter",
          children: [/*#__PURE__*/_jsx("div", {
            className: "l-columns__col l-products__side".concat(this.state.filtersOpen ? ' l-products__side--open' : ''),
            children: this.state.products.length ? /*#__PURE__*/_jsx(Filter, {
              filters: this.state.filters,
              addFilter: this.addFilter,
              removeFilter: this.removeFilter,
              clearFilters: this.clearFilters,
              usages: this.state.usages,
              materials: this.state.materials,
              handleToggleFilters: this.handleToggleFilters,
              filtersOpen: this.state.filtersOpen,
              sectors: this.state.sectors,
              currentSector: this.state.currentSector
            }) : null
          }), /*#__PURE__*/_jsxs("div", {
            className: "l-columns__col l-products__main",
            children: [/*#__PURE__*/_jsx(FilterToggle, {
              handleToggleFilters: this.handleToggleFilters,
              filters: this.state.filters,
              filtersOpen: this.state.filtersOpen
            }), /*#__PURE__*/_jsx(Toolbar, {
              layout: this.state.layout,
              sort: this.state.sort,
              changeLayout: this.changeLayout,
              changeSort: this.changeSort,
              totalProducts: totalProducts,
              pageLength: this.state.pageLength,
              handlePageChange: this.handlePageChange,
              start: start,
              end: end,
              activePage: this.state.activePage,
              variation: "top"
            }), /*#__PURE__*/_jsx("div", {
              className: "l-columns__col l-products__products".concat(this.state.noProducts ? ' l-products__products--none' : ''),
              children: this.state.productsLoaded ? this.renderProducts() : /*#__PURE__*/_jsxs("div", {
                className: "c-loader",
                children: [/*#__PURE__*/_jsx("div", {
                  className: "c-loader__bounce"
                }), /*#__PURE__*/_jsx("div", {
                  className: "c-loader__bounce"
                })]
              })
            }), /*#__PURE__*/_jsx(Toolbar, {
              layout: this.state.layout,
              sort: this.state.sort,
              changeLayout: this.changeLayout,
              changeSort: this.changeSort,
              totalProducts: totalProducts,
              pageLength: this.state.pageLength,
              handlePageChange: this.handlePageChange,
              start: start,
              end: end,
              activePage: this.state.activePage
            })]
          })]
        })
      }, "products")], this.container);
    }
  }]);
  return Products;
}(React.PureComponent);
Products.propTypes = {
  // dispatch: PropTypes.func.isRequired,
};
export default connect(function (state) {
  return state;
}, function (dispatch) {
  return {
    dispatch: dispatch
  };
})(Products);